import React from 'react';
import Button from 'react/components/button';

type SessionTimedOutModalProps = {
  modalInstance: any;
};

const SessionTimedOutModal = (props: SessionTimedOutModalProps) => {
  const { modalInstance } = props;

  const cancel = () => {
    modalInstance.dismiss('cancel');
  };

  return (
    <div>
      <div className="modal-header">
        <a aria-hidden="true" className="close-modal" onClick={cancel} title="Close">
          <i className="icon-cross"></i>
        </a>
        <h4 className="modal-title">Your Clubworx session has expired</h4>
      </div>
      <div className="modal-body modal-body-visible">
        <div className="margin-bottom-16">
          <span>Your session has expired. Please sign in to continue.</span>
        </div>
      </div>

      <div className="modal-footer">
        <Button
          variant="success"
          onClick={() => {
            window.location.href =
              '/users/sign_in?notice=Your session has expired. Please sign in to continue.';
          }}
        >
          Sign In
        </Button>
      </div>
    </div>
  );
};

angular.module('shared').value('SessionTimedOutModal', SessionTimedOutModal);
